module.exports = __webpack_public_path__ + "img/step1-c.6b37a57c.png";